import { memo } from 'react'
import PayCenter from '@/components/PayCenter/PayCenter'
import { usePayCenter } from '@/store/payCenterContext'

const GlobalPayCenter = () => {
  const { isPayCenterVisible, hidePayCenter, params } = usePayCenter()

  // 只有在需要显示时才渲染 PayCenter 组件
  if (!isPayCenterVisible) {
    return null
  }

  return <PayCenter visible={isPayCenterVisible} onCancel={hidePayCenter} {...params} />
}

export default memo(GlobalPayCenter)
